import { useMemo } from 'react';
import { Consumer } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { SalesforceV1 } from '@frontend/api-salesforce';

export const useGetLocationAddress = (locationSlug?: string) => {
  const { data: salesforceAccount } = SalesforceV1.Queries.useSalesforceAccountBySlugQuery({
    request: {
      slug: locationSlug,
      consumer: Consumer.INSYS,
    },
    options: {
      retry: false,
      enabled: !!locationSlug,
      select: (response) => response.account,
    },
  });

  const locationAddressText = useMemo(() => {
    if (!salesforceAccount) return '';

    const parts = [];

    if (salesforceAccount.billingStreet) {
      parts.push(salesforceAccount.billingStreet);
    }

    const cityState = [salesforceAccount.billingCity, salesforceAccount.billingStateCode].filter(Boolean).join(' ');

    if (cityState) {
      parts.push(cityState);
    }

    return parts.join(', ');
  }, [salesforceAccount]);

  return locationAddressText;
};
